webpackJsonp([203732303720079],{

/***/ 3871:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/complete-review-for-brian-flatts-2-week-diet-07-14-2018"},"frontmatter":{"title":"Complete Review For Brian Flatts 2 Week Diet","date":"2018-07-14"}}}]}},"pathContext":{"tag":"weight loss pills"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-weight-loss-pills-15b16d43a7f6ce91121c.js